import { UserRoleEnum } from '@/model/User';
import { SessionStorageEnum } from '@/utils/SessionStorageEnum';
import { RouteRecordRaw } from 'vue-router';
import { CustomersAppRoutesEnum } from './CustomersAppRoutesEnum';

const CustomersAppPage = () => import(/* webpackChunkName: "CustomersApp-module" */ '../pages/customers/CustomersAppPage.vue');
const CustomerAppPage = () => import(/* webpackChunkName: "CustomersApp-module" */ '../pages/customer/CustomerAppPage.vue');

const routes: Array<RouteRecordRaw> = [
  {
  path: '/app/customers',
    name: CustomersAppRoutesEnum.CUSTOMERS_APP_LIST,
    component: CustomersAppPage,
    meta: {
      tabTitle: 'Clienti App',
      breadCrumbItems: [
        { label: 'Elenco Clienti App' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
    beforeEnter(_, __, next) {
      sessionStorage.removeItem(SessionStorageEnum.TABLE_STATE_APP_CUSTOMER_DETAIL);
      next();
    },
  },
  {
  path: '/app/customers/:customerId',
    name: CustomersAppRoutesEnum.CUSTOMERS_APP_DETAIL,
    props: true,
    component: CustomerAppPage,
    meta: {
      tabTitle: 'Dettaglio Cliente App',
      breadCrumbItems: [
        { label: 'Elenco Clienti App', to: { name: CustomersAppRoutesEnum.CUSTOMERS_APP_LIST } },
        { label: 'Dettaglio Cliente App' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
  },
];

export { routes };
export { CustomersAppRoutesEnum };
